import {
  ServerActionWidget,
  SPI,
  ActionWidget,
  ActionType,
  ClickResult,
  RuntimeServerAction,
  SubmitValue
} from '@kunlun/dependencies';

/**
 * 经销商开票单 - 批量确认（部分打包）Action Widget
 * 绑定后端 BillingBillPartPackAction.partPack
 */
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.Server,
    name: 'partPack',
    model: ['deli.aries.settlement.BillingBillLine']
  })
)
export class PartPackActionWidget extends ServerActionWidget {
  protected executeAction(
    action: RuntimeServerAction,
    submitValue: SubmitValue
  ): Promise<ClickResult> {
    const submitValueCopy = { ...submitValue };
    submitValueCopy.records = this.activeRecords ?? [];
    return super.executeAction(action, submitValueCopy);
  }

  protected clickActionAfter(result: ClickResult): Promise<ClickResult> {
    return super.clickActionAfter(result);
  }
}
